import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp, faFacebookF, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { faMapMarkerAlt, faPhoneAlt, faEnvelope, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/img/logo/ji-impex.png';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <div className="container-fluid bg-dark footer mt-5 pt-5">
            <div className="container py-5">
                <div className="row g-5">

                    {/* Logo and Description */}
                    <div className="col-lg-4 col-md-6">
                        <Link to="/">
                            <img className="img-fluid company-logo" src={logo} alt="Ji Impex" />
                        </Link>
                        <p className="text-light">Marine Spare Parts, Equipments, and Industrial Automation all at one place.</p>
                        <div className="d-flex pt-2">
                            <a className="btn btn-square btn-outline-primary me-1" href="https://wa.me/+919316819979?text=Hello,%20I%20am%20intrested%20in%20your%20products" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faWhatsapp} />
                            </a>
                            <a className="btn btn-square btn-outline-primary me-1" href="https://www.facebook.com/share/15rm2uCHio/" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faFacebookF} />
                            </a>
                            <a className="btn btn-square btn-outline-primary me-1" href="https://www.instagram.com/j.i.impex?utm_source=qr&igsh=dGpydXZpN2RvMHZz" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faInstagram} />
                            </a>
                            <a className="btn btn-square btn-outline-primary me-0" href="https://www.linkedin.com/in/abdullah-hamidani-358a24351?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={faLinkedinIn} />
                            </a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className="col-lg-4 col-md-6">
                        <h4 className="text-light mb-4">Quick Links</h4>
                        <Link className="btn btn-link text-secondary footer-link" to="/"><FontAwesomeIcon icon={faChevronRight} /><span>Home</span></Link>
                        <Link className="btn btn-link text-secondary footer-link" to="/about"><FontAwesomeIcon icon={faChevronRight} /><span>About Us</span></Link>
                        <Link className="btn btn-link text-secondary footer-link" to="/contact"><FontAwesomeIcon icon={faChevronRight} /><span>Contact Us</span></Link>
                        {/* <Link className="btn btn-link text-secondary footer-link" to="/all-products"><FontAwesomeIcon icon={faChevronRight} /><span>All Products</span></Link> */}
                    </div>

                    {/* Address Section */}
                    <div className="col-lg-4 col-md-6">
                        <h4 className="text-light mb-4">Address</h4>
                        <p className="text-secondary">
                            <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" />
                            City Survey No.170/89 Pakki Plot No.89/B, Vibrant Industrial Park, Moti Talab Marg, Kumbhar Vada, Bhavnagar,Gujarat, 364006
                        </p>
                        <p className="text-secondary">
                            <FontAwesomeIcon icon={faPhoneAlt} className="me-2" />
                            <a href="tel:+919316819979" style={{ color: '#999' }}>+91 931 681 9979</a>
                        </p>
                        {/* <p className="text-secondary">
                            <FontAwesomeIcon icon={faPhoneAlt} className="me-2" />
                            <a href="tel:+919265677400" style={{ color: '#999' }}>+91 926 567 7400</a>
                        </p> */}
                        <p className="text-secondary">
                            <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                            <a href="mailto:sales@jiimpex.com" style={{ color: '#999' }}>sales@jiimpex.com</a>
                        </p>
                    </div>
                </div>
            </div>

            {/* Copyright Section */}
            <div className="container-fluid copyright">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 text-center text-md-start mb-3 mb-md-0 text-secondary">
                            &copy; Copyright 2025 <Link to="/">J.I. Impex</Link>, All Rights Reserved.
                        </div>
                        <div className="col-md-6 text-center text-md-end text-secondary">
                            Designed & Developed By <a href="https://ziaat.com/" target="_blank" rel="noopener noreferrer">Ziaat Technolabs Pvt. Ltd.</a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Back to Top Button */}
            <a href="#" className="btn btn-lg btn-primary btn-lg-square back-to-top">
                <i className="bi bi-arrow-up"></i>
            </a>

            {/* Floating WhatsApp Icon */}
            <a
                href="https://wa.me/+919316819979?text=Hello,%20I%20am%20interested%20in%20your%20products"
                className="floating-whatsapp"
                target="_blank"
                rel="noopener noreferrer"
            >
                <FontAwesomeIcon icon={faWhatsapp} />
            </a>
        </div>
    );
};

export default Footer;